module.exports = __webpack_public_path__ + "static/img/our-awards_3.d036c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/our-awards_3.png
// module id = BBL9
// module chunks = 0